import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { Interaction } from '../entities/interaction';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: Interaction | Interaction[];
  size: number;
}

interface ApiResponseQuantity {
  status: string;
  data: {
    "url_id": string;
    "profile_view": number;
    "whatsapp": number;
    "phone": number;
  }[]
}

@Injectable({
  providedIn: 'root'
})
export class InteractionService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private interactionServiceUrl = this.apiServicesUrl + '/interaction';

  postInteraction(interaction: Interaction): Observable<ApiResponse> {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post<ApiResponse>(this.interactionServiceUrl, interaction, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponse>('getInteractions'))
    );
  }

  getAllInteractionsByPerson(urlId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.interactionServiceUrl + 's/' + urlId)
    .pipe(
      catchError(this.handleError<ApiResponse>('getPerson'))
    );
  }

  getAllInteractions(): Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    return this.http.get<ApiResponse>(this.interactionServiceUrl, {headers: new HttpHeaders(
      {'Authorization': 'bearer ' + token}
    )})
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

  getAllInteractionsQuantities(): Observable<ApiResponseQuantity> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    return this.http.get<ApiResponseQuantity>(this.interactionServiceUrl + '-type', {headers: new HttpHeaders(
      {'Authorization': 'bearer ' + token}
    )})
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }
  
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
